document.documentElement.classList.remove('no-js');

const mobileMenuTransitionMs = 240;
const mobileMenuTimers = new WeakMap();

const setMobileMenuOpen = (mobileMenu, shouldOpen, returnFocus = false) => {
  const summary = mobileMenu?.querySelector('summary');
  const panel = mobileMenu?.querySelector('.bb-header__mobile-panel');
  if (!mobileMenu || !summary || !panel) return;

  const activeTimer = mobileMenuTimers.get(mobileMenu);
  if (activeTimer) clearTimeout(activeTimer);

  if (shouldOpen) {
    mobileMenu.open = true;
    panel.getBoundingClientRect();
    mobileMenu.classList.add('is-open');
    summary.setAttribute('aria-expanded', 'true');
    summary.setAttribute('aria-label', 'Cerrar menú');
    return;
  }

  mobileMenu.classList.remove('is-open');
  summary.setAttribute('aria-expanded', 'false');
  summary.setAttribute('aria-label', 'Abrir menú');

  const timer = window.setTimeout(() => {
    if (!mobileMenu.classList.contains('is-open')) mobileMenu.open = false;
    if (returnFocus) summary.focus();
    mobileMenuTimers.delete(mobileMenu);
  }, mobileMenuTransitionMs);

  mobileMenuTimers.set(mobileMenu, timer);
};

document.querySelectorAll('.bb-header__mobile').forEach((mobileMenu) => {
  const summary = mobileMenu.querySelector('summary');
  summary?.addEventListener('click', (event) => {
    event.preventDefault();
    setMobileMenuOpen(mobileMenu, !mobileMenu.classList.contains('is-open'));
  });
});


/* v1069 — AJAX cart count + right-side cart drawer */
const cartDrawerTransitionMs = 300;
let cartDrawerCloseTimer = null;
let lastCartTrigger = null;

const getCartRoot = () => window.Shopify?.routes?.root || '/';
const getCartJsonUrl = () => `${getCartRoot()}cart.js`;
const getCartChangeUrl = () => `${getCartRoot()}cart/change.js`;

const getCartDrawer = () => document.querySelector('[data-bb-cart-drawer]');

const getHeaderCartCount = () => {
  const node = document.querySelector('.bb-header__cart-count');
  const value = Number.parseInt(node?.textContent || '0', 10);
  return Number.isFinite(value) ? value : 0;
};

const updateHeaderCartCount = (count, animate = true) => {
  const normalizedCount = Math.max(0, Number.parseInt(count || '0', 10) || 0);

  document.querySelectorAll('.bb-header__cart-count').forEach((node) => {
    node.textContent = String(normalizedCount);
    if (animate) {
      node.classList.remove('is-bumped');
      void node.offsetWidth;
      node.classList.add('is-bumped');
      window.setTimeout(() => node.classList.remove('is-bumped'), 360);
    }
  });

  document.querySelectorAll('[data-bb-cart-link]').forEach((link) => {
    const label = link.dataset.bbCartLabel || 'Carrito';
    link.setAttribute('aria-label', `${label}: ${normalizedCount}`);
  });
};

const openCartDrawer = (trigger = null) => {
  const drawer = getCartDrawer();
  if (!drawer) return;

  if (cartDrawerCloseTimer) {
    window.clearTimeout(cartDrawerCloseTimer);
    cartDrawerCloseTimer = null;
  }

  if (trigger) lastCartTrigger = trigger;
  drawer.hidden = false;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('bb-cart-drawer-open');

  const mobileMenu = document.querySelector('.bb-header__mobile[open]');
  if (mobileMenu) setMobileMenuOpen(mobileMenu, false);

  window.requestAnimationFrame(() => {
    drawer.classList.add('is-open');
    drawer.querySelector('[data-bb-cart-drawer-close]')?.focus({ preventScroll: true });
  });
};

const closeCartDrawer = (returnFocus = true) => {
  const drawer = getCartDrawer();
  if (!drawer || drawer.hidden) return;

  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('bb-cart-drawer-open');

  const finish = () => {
    drawer.hidden = true;
    if (returnFocus && lastCartTrigger && typeof lastCartTrigger.focus === 'function') {
      lastCartTrigger.focus({ preventScroll: true });
    }
    if (returnFocus) lastCartTrigger = null;
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
  else cartDrawerCloseTimer = window.setTimeout(finish, cartDrawerTransitionMs);
};

const fetchCartState = async () => {
  const response = await fetch(getCartJsonUrl(), {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
  if (!response.ok) throw new Error('No se pudo actualizar el carrito.');
  return response.json();
};

const fetchCartDrawerSection = async () => {
  const sectionUrl = new URL(window.location.href);
  sectionUrl.hash = '';
  sectionUrl.searchParams.set('section_id', 'bb-cart-drawer');

  const response = await fetch(sectionUrl.toString(), {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
  if (!response.ok) throw new Error('No se pudo actualizar el panel del carrito.');
  return response.text();
};

const replaceCartDrawerSection = (html) => {
  const currentSection = document.getElementById('shopify-section-bb-cart-drawer');
  if (!currentSection || !html) return false;

  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const renderedSection = parsed.getElementById('shopify-section-bb-cart-drawer');

  if (renderedSection) currentSection.innerHTML = renderedSection.innerHTML;
  else currentSection.innerHTML = html;

  return true;
};

const keepCartDrawerOpen = (itemsScrollTop = 0) => {
  const drawer = getCartDrawer();
  if (!drawer) return;

  if (cartDrawerCloseTimer) {
    window.clearTimeout(cartDrawerCloseTimer);
    cartDrawerCloseTimer = null;
  }

  drawer.hidden = false;
  drawer.setAttribute('aria-hidden', 'false');
  drawer.classList.add('is-open');
  document.body.classList.add('bb-cart-drawer-open');

  const items = drawer.querySelector('[data-bb-cart-drawer-items]');
  if (items) items.scrollTop = Math.max(0, Number(itemsScrollTop) || 0);
};

const refreshCartDrawer = async ({ open = false, cart = null, trigger = null } = {}) => {
  const wrapper = document.getElementById('shopify-section-bb-cart-drawer');
  const currentDrawer = getCartDrawer();
  const preserveOpenState = Boolean(
    open &&
    currentDrawer &&
    !currentDrawer.hidden &&
    currentDrawer.classList.contains('is-open')
  );
  const previousItemsScrollTop = preserveOpenState
    ? currentDrawer.querySelector('[data-bb-cart-drawer-items]')?.scrollTop || 0
    : 0;
  wrapper?.classList.add('is-refreshing');

  try {
    const [cartState, sectionHtml] = await Promise.all([
      cart ? Promise.resolve(cart) : fetchCartState(),
      fetchCartDrawerSection(),
    ]);

    updateHeaderCartCount(cartState.item_count, false);
    replaceCartDrawerSection(sectionHtml);

    if (open) {
      if (preserveOpenState) keepCartDrawerOpen(previousItemsScrollTop);
      else openCartDrawer(trigger || lastCartTrigger);
    }
    return cartState;
  } finally {
    document.getElementById('shopify-section-bb-cart-drawer')?.classList.remove('is-refreshing');
  }
};

const buildCaseLineProperties = (existingProperties = {}, rawQuantity, unitsPerCase) => {
  const safeUnitsPerCase = Math.max(1, Number.parseInt(String(unitsPerCase || '1'), 10) || 1);
  const safeRawQuantity = Math.max(safeUnitsPerCase, Number.parseInt(String(rawQuantity || safeUnitsPerCase), 10) || safeUnitsPerCase);
  const caseCount = Math.max(1, Math.round(safeRawQuantity / safeUnitsPerCase));

  return {
    ...(existingProperties || {}),
    Cajas: String(caseCount),
    'U. / caja': String(safeUnitsPerCase),
    'Total unidades': String(safeRawQuantity),
  };
};


const getSelectedVariantDataNode = (form) => {
  if (!form) return null;
  const select = form.querySelector('[data-product-variant-select]');
  if (select) return select.options?.[select.selectedIndex] || null;
  return form.querySelector('input[name="id"]');
};

const getVariantInventoryMeta = (form) => {
  const node = getSelectedVariantDataNode(form);
  const parsedQuantity = Number.parseInt(node?.dataset.bbInventoryQuantity || '0', 10);
  return {
    managed: node?.dataset.bbInventoryManaged === 'true',
    quantity: Math.max(0, Number.isFinite(parsedQuantity) ? parsedQuantity : 0),
    available: node?.dataset.bbVariantAvailable !== 'false',
    policy: node?.dataset.bbInventoryPolicy || 'deny',
  };
};

const getCartVariantQuantity = (cart, variantId) => (cart?.items || []).reduce((total, item) => {
  return Number(item.variant_id) === Number(variantId) ? total + Number(item.quantity || 0) : total;
}, 0);

const buildInventoryErrorMessage = ({ remainingRaw = 0, maxRaw = null, isCase = false, unitsPerCase = 1, isSample = false } = {}) => {
  const safeRemaining = Math.max(0, Number.parseInt(String(remainingRaw || '0'), 10) || 0);
  const parsedMax = Number.parseInt(String(maxRaw ?? ''), 10);
  const safeMax = Number.isFinite(parsedMax) ? Math.max(0, parsedMax) : null;

  if (isCase) {
    const safeUnitsPerCase = Math.max(1, Number.parseInt(String(unitsPerCase || '1'), 10) || 1);
    const remainingCases = Math.floor(safeRemaining / safeUnitsPerCase);
    if (remainingCases <= 0) return 'No hay inventario suficiente para agregar otra caja.';
    return `Solo hay ${remainingCases} caja${remainingCases === 1 ? '' : 's'} disponible${remainingCases === 1 ? '' : 's'} (${remainingCases * safeUnitsPerCase} unidades).`;
  }

  if (safeMax !== null && safeMax > 0) {
    return `Puedes comprar hasta ${safeMax} unidades de este producto.`;
  }
  if (safeRemaining <= 0) return isSample ? 'Esta muestra está agotada.' : 'Este producto está agotado.';
  return `Puedes comprar hasta ${safeRemaining} unidades de este producto.`;
};

const showCartDrawerStatus = (message = '') => {
  const status = getCartDrawer()?.querySelector('[data-bb-cart-drawer-status]');
  if (!status) return;
  status.textContent = message;
  status.hidden = !message;
};

const postCartLineChange = async ({ id, quantity, properties = null }) => {
  const body = { id, quantity };
  if (properties && quantity > 0) body.properties = properties;

  const response = await fetch(getCartChangeUrl(), {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(body),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.description || payload.message || 'No se pudo actualizar el carrito.');
  }
  return payload;
};

const changeCartLine = async (lineKey, quantity, caseUnits = 0) => {
  const drawer = getCartDrawer();
  drawer?.classList.add('is-updating');

  try {
    let properties = null;
    const normalizedCaseUnits = Math.max(0, Number.parseInt(String(caseUnits || '0'), 10) || 0);

    if (quantity > 0 && normalizedCaseUnits > 0) {
      const currentCart = await fetchCartState();
      const currentItem = (currentCart.items || []).find((item) => item.key === lineKey);
      properties = buildCaseLineProperties(currentItem?.properties || {}, quantity, normalizedCaseUnits);
    }

    const payload = await postCartLineChange({ id: lineKey, quantity, properties });
    updateHeaderCartCount(payload.item_count, true);
    await refreshCartDrawer({ open: true, cart: payload });
  } catch (error) {
    console.error(error);
    const message = error?.message || 'No se pudo actualizar el carrito.';
    await refreshCartDrawer({ open: true }).catch(() => {});
    showCartDrawerStatus(message);
  }
};

document.addEventListener('click', (event) => {
  const cartLink = event.target.closest('[data-bb-cart-link]');
  if (cartLink) {
    event.preventDefault();
    lastCartTrigger = cartLink;
    refreshCartDrawer({ open: true, trigger: cartLink }).catch(() => {
      window.location.href = cartLink.href;
    });
    return;
  }

  if (event.target.closest('[data-bb-cart-drawer-close], [data-bb-cart-drawer-backdrop]')) {
    event.preventDefault();
    closeCartDrawer(true);
    return;
  }

  const removeButton = event.target.closest('[data-bb-cart-remove]');
  if (removeButton) {
    event.preventDefault();
    const lineKey = removeButton.dataset.bbCartLineKey;
    if (lineKey) changeCartLine(lineKey, 0);
    return;
  }

  const quantityButton = event.target.closest('[data-bb-cart-qty-action]');
  if (quantityButton) {
    event.preventDefault();
    if (quantityButton.disabled) return;

    const lineKey = quantityButton.dataset.bbCartLineKey;
    const current = Math.max(0, Number.parseInt(quantityButton.dataset.bbCartRawQuantity || '0', 10) || 0);
    const step = Math.max(1, Number.parseInt(quantityButton.dataset.bbCartStep || '1', 10) || 1);
    const minimum = Math.max(0, Number.parseInt(quantityButton.dataset.bbCartMin || '0', 10) || 0);
    const parsedMaximum = Number.parseInt(quantityButton.dataset.bbCartMax || '999999', 10);
    const maximum = Number.isFinite(parsedMaximum) ? Math.max(0, parsedMaximum) : 999999;
    const direction = quantityButton.dataset.bbCartQtyAction === 'decrease' ? -1 : 1;
    const attemptedQuantity = direction < 0 ? current - step : current + step;
    const nextQuantity = direction < 0
      ? Math.max(minimum, attemptedQuantity)
      : Math.min(maximum, attemptedQuantity);
    const caseUnits = Math.max(0, Number.parseInt(quantityButton.dataset.bbCartCaseUnits || '0', 10) || 0);
    const parsedStockMaximum = Number.parseInt(quantityButton.dataset.bbCartStockMax || '', 10);
    const stockMaximum = Number.isFinite(parsedStockMaximum) ? Math.max(0, parsedStockMaximum) : null;

    if (direction > 0 && attemptedQuantity > maximum) {
      if (stockMaximum !== null && maximum === stockMaximum) {
        showCartDrawerStatus(`Puedes comprar hasta ${stockMaximum} unidades de este producto.`);
      } else if (caseUnits > 0) {
        showCartDrawerStatus('Para 10 cajas o más, solicita una cotización.');
      }
      return;
    }

    showCartDrawerStatus('');
    if (lineKey && nextQuantity !== current) changeCartLine(lineKey, nextQuantity, caseUnits);
  }
});

document.addEventListener('keydown', (event) => {
  const drawer = getCartDrawer();
  if (!drawer || drawer.hidden) return;

  if (event.key === 'Escape') {
    closeCartDrawer(true);
    return;
  }

  if (event.key === 'Tab') {
    const focusable = Array.from(drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => !element.hidden && element.getClientRects().length > 0);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
});

const getSamePageSection = (anchor) => {
  const mobileTarget = anchor?.dataset.mobileContactTarget;
  const href = mobileTarget && window.matchMedia('(max-width: 749px)').matches
    ? mobileTarget
    : anchor?.getAttribute('href');
  if (!href || href === '#') return null;

  try {
    const url = new URL(href, window.location.href);
    if (
      url.origin !== window.location.origin ||
      url.pathname !== window.location.pathname ||
      url.search !== window.location.search ||
      !url.hash
    ) return null;

    const sectionId = decodeURIComponent(url.hash.slice(1));
    const target = document.getElementById(sectionId);
    return target ? { target, hash: url.hash } : null;
  } catch (error) {
    return null;
  }
};

const scrollSectionBelowHeader = (target) => {
  const header = document.querySelector('.bb-header');
  const headerHeight = header?.getBoundingClientRect().height || 0;
  const mobileContactGap = target.id === 'cotizar' && window.matchMedia('(max-width: 749px)').matches
    ? 24
    : 0;
  const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight - mobileContactGap;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.scrollTo({
    top: Math.max(0, Math.round(targetTop)),
    behavior: reduceMotion ? 'auto' : 'smooth'
  });
};

document.addEventListener('click', (event) => {
  const anchor = event.target.closest('a[href]');
  const section = getSamePageSection(anchor);
  if (!section) return;

  event.preventDefault();

  const mobileMenu = anchor.closest('.bb-header__mobile');
  if (mobileMenu?.open) setMobileMenuOpen(mobileMenu, false);

  window.requestAnimationFrame(() => {
    scrollSectionBelowHeader(section.target);
    if (window.location.hash !== section.hash) {
      window.history.pushState(null, '', section.hash);
    }
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const mobileMenu = document.querySelector('.bb-header__mobile[open]');
  if (!mobileMenu) return;

  setMobileMenuOpen(mobileMenu, false, true);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-product-variant-select]');
  if (!select) return;

  const form = select.closest('form');
  const option = select.options[select.selectedIndex];
  if (!form || !option) return;

  const price = form.closest('.bb-main-product__info')?.querySelector('.bb-main-product__price');
  if (price && option.dataset.bbVariantPrice) {
    price.textContent = option.dataset.bbVariantPrice;
  }
});


const initializeAjaxProductForms = (root = document) => {
  root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    if (!form.querySelector('[data-add-to-cart]')) return;
    if (form.dataset.bbAjaxCartReady === 'true') return;
    form.dataset.bbAjaxCartReady = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      // Prevent a second purchase request while the first is still in flight.
      if (form.dataset.bbCartSubmitting === 'true') return;
      form.dataset.bbCartSubmitting = 'true';

      const button = form.querySelector('[data-add-to-cart]');
      const status = form.querySelector('[data-bb-product-form-status]');
      const select = form.querySelector('[data-product-variant-select]');
      const selectedOption = select?.options?.[select.selectedIndex];
      const purchaseQuantity = form.querySelector('[data-bb-purchase-quantity]');
      const hiddenQuantity = form.querySelector('[data-bb-shopify-quantity]');
      const selectedIsSample = selectedOption?.dataset.bbSampleVariant === 'true';
      const isCaseProduct = purchaseQuantity?.dataset.bbIsCase === 'true';
      const isCasePurchase = isCaseProduct && !selectedIsSample;
      // 1-caja products (both caja and sample variants) are preorderable regardless of Shopify stock.
      // 10-unidades products continue to respect live Shopify inventory.
      const shouldRespectInventory = !isCaseProduct;
      const unitsPerCase = Math.max(1, Number.parseInt(purchaseQuantity?.dataset.bbUnitsPerCase || '1', 10) || 1);
      const requestedCaseCount = Math.max(1, Number.parseInt(purchaseQuantity?.value || '1', 10) || 1);
      const requestedRawQuantity = Math.max(1, Number.parseInt(hiddenQuantity?.value || '1', 10) || 1);
      const variantField = form.querySelector('[name="id"]');
      const selectedVariantId = Number.parseInt(select?.value || variantField?.value || '', 10);
      const inventoryMeta = getVariantInventoryMeta(form);

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Agregando…';
      if (status) {
        status.textContent = '';
        status.className = 'bb-product-form__status';
      }

      try {
        if (!selectedVariantId) throw new Error('Selecciona una opción válida.');

        const typedDisplayQuantity = Number.parseInt(String(purchaseQuantity?.value || ''), 10);
        if (!selectedIsSample && !isCaseProduct && (!Number.isFinite(typedDisplayQuantity) || typedDisplayQuantity < 10)) {
          throw new Error('El pedido mínimo es de 10 unidades.');
        }

        const currentCart = await fetchCartState();
        const existingVariantQuantity = getCartVariantQuantity(currentCart, selectedVariantId);
        if (!selectedIsSample && !isCaseProduct && existingVariantQuantity + requestedRawQuantity > 299) {
          throw new Error('Para 300 unidades o más de un producto, solicita una cotización.');
        }
        const remainingInventory = shouldRespectInventory && inventoryMeta.managed
          ? Math.max(0, inventoryMeta.quantity - existingVariantQuantity)
          : null;

        if (shouldRespectInventory && !inventoryMeta.available) {
          if (inventoryMeta.managed && inventoryMeta.quantity > 0) {
            throw new Error('Este producto no está disponible para pedidos online.');
          }
          throw new Error(buildInventoryErrorMessage({
            remainingRaw: 0,
            maxRaw: inventoryMeta.quantity,
            isCase: isCasePurchase,
            unitsPerCase,
            isSample: selectedIsSample,
          }));
        }

        if (shouldRespectInventory && inventoryMeta.managed && requestedRawQuantity > remainingInventory) {
          throw new Error(buildInventoryErrorMessage({
            remainingRaw: remainingInventory,
            maxRaw: inventoryMeta.quantity,
            isCase: isCasePurchase,
            unitsPerCase,
            isSample: selectedIsSample,
          }));
        }

        const sampleLimitOne = form.dataset.bbSampleLimitOne === 'true';
        if (sampleLimitOne && selectedIsSample) {
          if (hiddenQuantity) hiddenQuantity.value = '1';
          const existingSample = (currentCart.items || []).find((item) => Number(item.variant_id) === selectedVariantId);
          if (existingSample && Number(existingSample.quantity) >= 1) {
            throw new Error('Cada muestra de THENEWGREY está limitada a 1 unidad por producto.');
          }
        }

        if (isCasePurchase) {
          const caseCountProperty = form.querySelector('[data-bb-case-count-property]');
          const caseUnitsProperty = form.querySelector('[data-bb-case-units-property]');
          const caseTotalProperty = form.querySelector('[data-bb-case-total-property]');

          [caseCountProperty, caseUnitsProperty, caseTotalProperty].forEach((input) => {
            if (input) input.disabled = false;
          });
          if (caseCountProperty) caseCountProperty.value = String(requestedCaseCount);
          if (caseUnitsProperty) caseUnitsProperty.value = String(unitsPerCase);
          if (caseTotalProperty) caseTotalProperty.value = String(requestedRawQuantity);

          const existingCaseLine = (currentCart.items || []).find((item) => Number(item.variant_id) === selectedVariantId);
          if (existingCaseLine) {
            const combinedRawQuantity = Number(existingCaseLine.quantity || 0) + requestedRawQuantity;
            const combinedCaseCount = combinedRawQuantity / unitsPerCase;

            if (!Number.isInteger(combinedCaseCount)) {
              throw new Error('No se pudo combinar este producto por caja. Actualiza el carrito e inténtalo de nuevo.');
            }
            if (combinedCaseCount > 9) {
              throw new Error('Para 10 cajas o más, solicita una cotización.');
            }
            if (shouldRespectInventory && inventoryMeta.managed && combinedRawQuantity > inventoryMeta.quantity) {
              throw new Error(buildInventoryErrorMessage({
                remainingRaw: remainingInventory,
                maxRaw: inventoryMeta.quantity,
                isCase: true,
                unitsPerCase,
              }));
            }

            const mergedProperties = buildCaseLineProperties(
              existingCaseLine.properties || {},
              combinedRawQuantity,
              unitsPerCase
            );
            const mergedCart = await postCartLineChange({
              id: existingCaseLine.key,
              quantity: combinedRawQuantity,
              properties: mergedProperties,
            });

            updateHeaderCartCount(mergedCart.item_count, true);
            if (status) {
              status.textContent = 'Agregado al carrito.';
              status.className = 'bb-product-form__status is-success';
            }
            button.textContent = 'Agregado';
            refreshCartDrawer({ open: true, cart: mergedCart }).catch((drawerError) => console.error(drawerError));

            window.setTimeout(() => {
              button.disabled = false;
              button.textContent = originalText;
              purchaseQuantity?.dispatchEvent(new Event('change', { bubbles: true }));
            }, 900);
            return;
          }
        }

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(form),
        });

        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          const serverMessage = payload.description || payload.message || 'No se pudo agregar el producto.';
          const soldOut = /agotad|sold out|not enough|inventory|stock|quantity/i.test(serverMessage);
          const inventoryMessage = inventoryMeta.managed && inventoryMeta.quantity > 0
            ? `Puedes comprar hasta ${inventoryMeta.quantity} unidades de este producto.`
            : 'No hay inventario suficiente para la cantidad seleccionada.';
          throw new Error(soldOut ? inventoryMessage : serverMessage);
        }

        const addedQuantity = Math.max(
          1,
          Number.parseInt(String(payload.quantity || hiddenQuantity?.value || '1'), 10) || 1
        );
        updateHeaderCartCount(getHeaderCartCount() + addedQuantity, true);

        if (status) {
          status.textContent = 'Agregado al carrito.';
          status.className = 'bb-product-form__status is-success';
        }
        button.textContent = 'Agregado';

        refreshCartDrawer({ open: true }).catch((drawerError) => {
          console.error(drawerError);
          fetchCartState()
            .then((cartState) => updateHeaderCartCount(cartState.item_count, false))
            .catch(() => {});
        });

        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
          purchaseQuantity?.dispatchEvent(new Event('change', { bubbles: true }));
        }, 900);
      } catch (error) {
        if (status) {
          status.textContent = error?.message || 'No se pudo agregar el producto.';
          status.className = 'bb-product-form__status is-error';
        }
        button.disabled = false;
        button.textContent = originalText;
        purchaseQuantity?.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        delete form.dataset.bbCartSubmitting;
      }
    });
  });
};


// v1073 — show the exact maximum purchasable quantity when a 10-unit product exceeds live stock.


initializeAjaxProductForms();
document.addEventListener('shopify:section:load', (event) => initializeAjaxProductForms(event.target));

const brandImageBounds = new WeakMap();

const median = (values) => {
  const sorted = [...values].sort((a, b) => a - b);
  return sorted[Math.floor(sorted.length / 2)];
};

const analyzeBrandImage = (image) => {
  const naturalWidth = image.naturalWidth;
  const naturalHeight = image.naturalHeight;
  if (!naturalWidth || !naturalHeight) return null;

  const sampleScale = Math.min(1, 180 / naturalWidth, 180 / naturalHeight);
  const width = Math.max(1, Math.round(naturalWidth * sampleScale));
  const height = Math.max(1, Math.round(naturalHeight * sampleScale));
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d', { willReadFrequently: true });
  if (!context) return null;

  canvas.width = width;
  canvas.height = height;
  context.clearRect(0, 0, width, height);
  context.drawImage(image, 0, 0, width, height);

  const pixels = context.getImageData(0, 0, width, height).data;
  const cornerIndexes = [
    0,
    (width - 1) * 4,
    (height - 1) * width * 4,
    ((height - 1) * width + width - 1) * 4
  ];
  const background = [0, 1, 2, 3].map((channel) =>
    median(cornerIndexes.map((index) => pixels[index + channel]))
  );

  let minX = width;
  let minY = height;
  let maxX = -1;
  let maxY = -1;
  let visiblePixels = 0;

  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      const index = (y * width + x) * 4;
      const alpha = pixels[index + 3];
      const alphaDifference = Math.abs(alpha - background[3]);
      const colorDifference = Math.max(
        Math.abs(pixels[index] - background[0]),
        Math.abs(pixels[index + 1] - background[1]),
        Math.abs(pixels[index + 2] - background[2])
      );
      const isVisible = background[3] < 32
        ? alpha > 32
        : alpha > 16 && (colorDifference > 24 || alphaDifference > 24);

      if (!isVisible) continue;
      visiblePixels += 1;
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
    }
  }

  if (visiblePixels < 12 || maxX < minX || maxY < minY) return null;

  return {
    centerX: ((minX + maxX + 1) / 2) / width,
    centerY: ((minY + maxY + 1) / 2) / height,
    width: (maxX - minX + 1) / width,
    height: (maxY - minY + 1) / height
  };
};

const positionBrandImage = (image, refreshBounds = false) => {
  if (image.dataset.autoCenter !== 'true') {
    image.style.removeProperty('--bb-image-auto-offset-x');
    image.style.removeProperty('--bb-image-auto-offset-y');
    image.style.removeProperty('--bb-image-auto-scale');
    return;
  }

  if (!image.complete || !image.naturalWidth || !image.naturalHeight) return;

  try {
    if (refreshBounds || !brandImageBounds.has(image)) {
      brandImageBounds.set(image, analyzeBrandImage(image));
    }

    const bounds = brandImageBounds.get(image);
    if (!bounds) return;

    const box = image.getBoundingClientRect();
    const fit = getComputedStyle(image).objectFit;
    const scaleX = box.width / image.naturalWidth;
    const scaleY = box.height / image.naturalHeight;
    const renderedScale = fit === 'cover'
      ? Math.max(scaleX, scaleY)
      : Math.min(scaleX, scaleY);
    const mediaBox = image.closest('.bb-brand-logo-media')?.getBoundingClientRect() || box;
    const visibleWidth = Math.max(1, bounds.width * image.naturalWidth * renderedScale);
    const visibleHeight = Math.max(1, bounds.height * image.naturalHeight * renderedScale);
    const targetWidth = mediaBox.width * 0.88;
    const targetHeight = mediaBox.height * 0.68;
    const autoScale = Math.max(
      1,
      Math.min(2.5, targetWidth / visibleWidth, targetHeight / visibleHeight)
    );
    const maxOffsetX = mediaBox.width * 0.45;
    const maxOffsetY = mediaBox.height * 0.45;
    const offsetX = Math.max(
      -maxOffsetX,
      Math.min(maxOffsetX, (0.5 - bounds.centerX) * image.naturalWidth * renderedScale * autoScale)
    );
    const offsetY = Math.max(
      -maxOffsetY,
      Math.min(maxOffsetY, (0.5 - bounds.centerY) * image.naturalHeight * renderedScale * autoScale)
    );

    image.style.setProperty('--bb-image-auto-offset-x', `${offsetX.toFixed(2)}px`);
    image.style.setProperty('--bb-image-auto-offset-y', `${offsetY.toFixed(2)}px`);
    image.style.setProperty('--bb-image-auto-scale', autoScale.toFixed(3));
  } catch (error) {
    image.style.removeProperty('--bb-image-auto-offset-x');
    image.style.removeProperty('--bb-image-auto-offset-y');
    image.style.removeProperty('--bb-image-auto-scale');
  }
};

const initializeBrandImages = (root = document) => {
  root.querySelectorAll('[data-bb-brand-image]').forEach((image) => {
    if (image.dataset.centerListener !== 'true') {
      image.dataset.centerListener = 'true';
      image.addEventListener('load', () => positionBrandImage(image, true));
    }
    positionBrandImage(image);
  });
};

initializeBrandImages();

document.addEventListener('shopify:section:load', (event) => {
  initializeBrandImages(event.target);
});

let brandImageResizeFrame;
let brandImageViewportWidth = document.documentElement.clientWidth;
window.addEventListener('resize', () => {
  const currentViewportWidth = document.documentElement.clientWidth;
  if (Math.abs(currentViewportWidth - brandImageViewportWidth) < 2) return;
  brandImageViewportWidth = currentViewportWidth;

  window.cancelAnimationFrame(brandImageResizeFrame);
  brandImageResizeFrame = window.requestAnimationFrame(() => {
    document.querySelectorAll('[data-bb-brand-image]').forEach((image) => positionBrandImage(image));
  });
});

const initializeHorizontalScrollTracks = (root = document) => {
  root.querySelectorAll('[data-bb-horizontal-scroll]').forEach((track) => {
    if (track.dataset.horizontalScrollReady === 'true') return;
    track.dataset.horizontalScrollReady = 'true';

    let pointerId;
    let pointerStartX = 0;
    let scrollStart = 0;
    let dragged = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (track.scrollWidth <= track.clientWidth + 2) return;

      pointerId = event.pointerId;
      pointerStartX = event.clientX;
      scrollStart = track.scrollLeft;
      dragged = false;
    });

    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const distance = event.clientX - pointerStartX;
      if (!dragged && Math.abs(distance) > 10) {
        dragged = true;
        track.setPointerCapture(pointerId);
        track.classList.add('is-dragging');
      }
      if (!dragged) return;

      event.preventDefault();
      track.scrollLeft = scrollStart - distance;
    });

    const endDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
      track.classList.remove('is-dragging');

      if (dragged) {
        track.dataset.suppressClick = 'true';
        window.setTimeout(() => delete track.dataset.suppressClick, 0);
      }

      pointerId = undefined;
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('click', (event) => {
      if (track.dataset.suppressClick !== 'true') return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();

      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({
        left: direction * track.clientWidth * 0.9,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });
  });
};

initializeHorizontalScrollTracks();

document.addEventListener('shopify:section:load', (event) => {
  initializeHorizontalScrollTracks(event.target);
});

const initializeProductCardLinks = (root = document) => {
  root.querySelectorAll('[data-bb-product-card-link]').forEach((card) => {
    if (card.dataset.productCardLinkReady === 'true') return;
    card.dataset.productCardLinkReady = 'true';

    card.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const track = card.closest('[data-bb-horizontal-scroll]');
      if (track?.dataset.suppressClick === 'true') return;

      event.preventDefault();
      window.location.assign(card.href);
    });
  });
};

initializeProductCardLinks();

document.addEventListener('shopify:section:load', (event) => {
  initializeProductCardLinks(event.target);
});

const initializeBrandToggles = (root = document) => {
  root.querySelectorAll('[data-bb-brand-toggle]').forEach((button) => {
    if (button.dataset.brandToggleReady === 'true') return;

    const listId = button.getAttribute('aria-controls');
    const list = listId ? document.getElementById(listId) : null;
    if (!list) return;

    button.dataset.brandToggleReady = 'true';
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;
      list.classList.toggle('is-expanded', nextExpanded);
      button.setAttribute('aria-expanded', String(nextExpanded));
      button.textContent = nextExpanded
        ? button.dataset.hideLabel || 'Ver menos'
        : button.dataset.showLabel || 'Ver todo';
    });
  });
};

initializeBrandToggles();

document.addEventListener('shopify:section:load', (event) => {
  initializeBrandToggles(event.target);
});

const updateProductCarousel = (carousel) => {
  const track = carousel.querySelector('[data-bb-product-track]');
  const previous = carousel.querySelector('[data-bb-product-previous]');
  const next = carousel.querySelector('[data-bb-product-next]');
  if (!track || !previous || !next) return;

  const desktop = window.matchMedia('(min-width: 990px)').matches;
  const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
  const hasOverflow = desktop && maxScroll > 2;
  carousel.classList.toggle('has-overflow', hasOverflow);
  previous.disabled = !hasOverflow || track.scrollLeft <= 2;
  next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
};

const moveProductCarousel = (carousel, direction) => {
  const track = carousel.querySelector('[data-bb-product-track]');
  const card = track?.querySelector('.bb-product-card');
  if (!track || !card) return;

  const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  track.scrollBy({
    left: direction * (card.getBoundingClientRect().width + gap),
    behavior: reduceMotion ? 'auto' : 'smooth'
  });
};

const initializeProductCarousels = (root = document) => {
  root.querySelectorAll('[data-bb-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-bb-product-track]');
    const previous = carousel.querySelector('[data-bb-product-previous]');
    const next = carousel.querySelector('[data-bb-product-next]');
    if (!track || !previous || !next) return;

    if (carousel.dataset.productCarouselReady !== 'true') {
      carousel.dataset.productCarouselReady = 'true';
      previous.addEventListener('click', () => moveProductCarousel(carousel, -1));
      next.addEventListener('click', () => moveProductCarousel(carousel, 1));
      track.addEventListener('scroll', () => updateProductCarousel(carousel), { passive: true });
    }

    updateProductCarousel(carousel);
  });
};

initializeProductCarousels();

document.addEventListener('shopify:section:load', (event) => {
  initializeProductCarousels(event.target);
});

let productCarouselResizeFrame;
window.addEventListener('resize', () => {
  window.cancelAnimationFrame(productCarouselResizeFrame);
  productCarouselResizeFrame = window.requestAnimationFrame(() => {
    document.querySelectorAll('[data-bb-product-carousel]').forEach(updateProductCarousel);
  });
});

const initializeProductGalleries = (root = document) => {
  root.querySelectorAll('[data-bb-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.productGalleryReady === 'true') return;
    const mainImage = gallery.querySelector('[data-bb-product-main-image]');
    const mainMedia = gallery.querySelector('[data-bb-product-main-media]');
    const thumbnails = Array.from(gallery.querySelectorAll('[data-bb-product-thumbnail]'));
    if (!mainImage) return;
    gallery.dataset.productGalleryReady = 'true';

    // Match the displayed responsive candidate, including on high-DPI phones.
    const imageSizes = mainImage.sizes || '100vw';
    const applyThumbnailImage = (image, thumbnail) => {
      image.loading = 'eager';
      image.decoding = 'async';
      image.sizes = imageSizes;
      image.srcset = thumbnail.dataset.imageSrcset || '';
      image.src = thumbnail.dataset.imageSrc;
      image.alt = thumbnail.dataset.imageAlt || '';
      image.dataset.fullSrc = thumbnail.dataset.imageFullSrc || thumbnail.dataset.imageSrc;
      if (thumbnail.dataset.imageWidth) image.width = Number(thumbnail.dataset.imageWidth);
      if (thumbnail.dataset.imageHeight) image.height = Number(thumbnail.dataset.imageHeight);
    };
    const waitForImage = (image) => new Promise((resolve, reject) => {
      let timer;
      const cleanup = () => {
        clearTimeout(timer);
        image.removeEventListener('load', loaded);
        image.removeEventListener('error', failed);
      };
      const failed = () => { cleanup(); reject(new Error('Gallery image unavailable')); };
      const loaded = async () => {
        cleanup();
        if (!image.naturalWidth) { reject(new Error('Gallery image unavailable')); return; }
        // Some browsers reject decode() for an otherwise valid cached image.
        if (image.decode) await image.decode().catch(() => {});
        resolve(image);
      };
      if (image.complete) { image.naturalWidth ? loaded() : failed(); return; }
      image.addEventListener('load', loaded, { once: true });
      image.addEventListener('error', failed, { once: true });
      timer = setTimeout(failed, 20000);
    });
    const cache = new Map();
    const loadThumbnail = (thumbnail) => {
      const key = thumbnail.dataset.imageSrc + '|' + (thumbnail.dataset.imageSrcset || '');
      if (cache.has(key)) return cache.get(key);
      const image = new Image();
      applyThumbnailImage(image, thumbnail);
      const promise = waitForImage(image).catch((error) => { cache.delete(key); throw error; });
      cache.set(key, promise);
      return promise;
    };
    const activeIndex = () => Math.max(0, thumbnails.findIndex(item => item.classList.contains('is-active')));
    const preloadAdjacentImages = () => {
      const index = activeIndex();
      [index - 1, index + 1].forEach(i => {
        if (thumbnails[i]) loadThumbnail(thumbnails[i]).catch(() => {});
      });
    };
    const updateThumbnailState = (thumbnail, scroll = false) => {
      thumbnails.forEach(item => {
        item.classList.toggle('is-active', item === thumbnail);
        item.setAttribute('aria-pressed', String(item === thumbnail));
      });
      if (scroll) thumbnail.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      preloadAdjacentImages();
    };
    let selectionId = 0;
    let cancelMotion = () => {};
    const selectThumbnail = async (thumbnail, scroll = false) => {
      if (!thumbnail?.dataset.imageSrc) return;
      const id = ++selectionId;
      cancelMotion();
      mainMedia?.setAttribute('aria-busy', 'true');
      try {
        await loadThumbnail(thumbnail);
        if (id !== selectionId) return;
        applyThumbnailImage(mainImage, thumbnail);
        updateThumbnailState(thumbnail, scroll);
      } catch (_) {
        // Leave the current image and active thumbnail intact. A tap can retry.
      } finally {
        if (id === selectionId) mainMedia?.removeAttribute('aria-busy');
      }
    };
    thumbnails.forEach(thumbnail => thumbnail.addEventListener('click', () => selectThumbnail(thumbnail)));
    preloadAdjacentImages();

    if (!mainMedia || thumbnails.length < 2) return;
    let touchStartX = 0, touchStartY = 0, lastTouchX = 0, lastTouchTime = 0;
    let touchActive = false, horizontalDrag = false;
    let previewImage = null, targetThumbnail = null, swipeSide = 0, currentDeltaX = 0;
    let motionId = 0, motionTimer = null, motionFrame = null, settling = false;
    const isMobileGallery = () => window.matchMedia('(max-width: 989px)').matches;
    const clearInlineMotion = () => {
      ++motionId;
      clearTimeout(motionTimer);
      cancelAnimationFrame(motionFrame);
      settling = false;
      mainImage.style.transition = '';
      mainImage.style.transform = '';
      mainImage.style.willChange = '';
      mainMedia.classList.remove('is-swiping');
      previewImage?.remove();
      previewImage = null;
      targetThumbnail = null;
      swipeSide = 0;
      currentDeltaX = 0;
    };
    cancelMotion = clearInlineMotion;
    const previewReady = () => previewImage?.complete && previewImage.naturalWidth > 0;
    const setDragPosition = (deltaX) => {
      const width = Math.max(mainMedia.clientWidth, 1);
      // Never drag the current image away to reveal an unloaded preview.
      mainImage.style.transition = 'none';
      mainImage.style.transform = `translate3d(${previewReady() ? deltaX : 0}px, 0, 0)`;
      mainImage.style.willChange = 'transform';
      if (previewImage) {
        previewImage.style.transition = 'none';
        previewImage.style.transform = `translate3d(${swipeSide * width + deltaX}px, 0, 0)`;
        previewImage.style.visibility = previewReady() ? 'visible' : 'hidden';
      }
    };
    const prepareSwipeTarget = (deltaX) => {
      const side = deltaX < 0 ? 1 : -1;
      const next = thumbnails[activeIndex() + side];
      if (next === targetThumbnail && side === swipeSide) return Boolean(next);
      previewImage?.remove();
      previewImage = null;
      targetThumbnail = next || null;
      swipeSide = next ? side : 0;
      if (!next) return false;
      const image = document.createElement('img');
      image.className = 'bb-product-gallery__swipe-image';
      image.draggable = false;
      image.style.visibility = 'hidden';
      applyThumbnailImage(image, next);
      mainMedia.appendChild(image);
      previewImage = image;
      mainMedia.classList.add('is-swiping');
      waitForImage(image).then(() => {
        if (previewImage === image && horizontalDrag && !settling) setDragPosition(currentDeltaX);
      }).catch(() => {});
      return true;
    };
    const animateBack = () => {
      if (!previewImage && !horizontalDrag) { clearInlineMotion(); return; }
      settling = true;
      const id = motionId;
      mainImage.style.transition = 'transform 220ms ease-out';
      mainImage.style.transform = 'translate3d(0, 0, 0)';
      if (previewImage) {
        previewImage.style.transition = 'transform 220ms ease-out';
        previewImage.style.transform = `translate3d(${swipeSide * mainMedia.clientWidth}px, 0, 0)`;
      }
      motionTimer = setTimeout(() => { if (id === motionId) clearInlineMotion(); }, 250);
    };
    const animateToTarget = () => {
      const thumbnail = targetThumbnail;
      if (!thumbnail || !previewImage) { animateBack(); return; }
      if (!previewReady()) {
        // Slow network: restore the current frame while waiting for the target.
        clearInlineMotion();
        selectThumbnail(thumbnail, true);
        return;
      }
      settling = true;
      const id = motionId;
      const selection = ++selectionId;
      const preview = previewImage;
      mainImage.style.transition = 'transform 300ms cubic-bezier(0.22, 0.61, 0.36, 1)';
      preview.style.transition = mainImage.style.transition;
      mainImage.style.transform = `translate3d(${-swipeSide * mainMedia.clientWidth}px, 0, 0)`;
      preview.style.transform = 'translate3d(0, 0, 0)';
      motionTimer = setTimeout(async () => {
        if (id !== motionId || selection !== selectionId) return;
        applyThumbnailImage(mainImage, thumbnail);
        mainImage.style.transition = 'none';
        mainImage.style.transform = 'translate3d(0, 0, 0)';
        // Keep the decoded preview covering the main image until it is ready.
        try { await waitForImage(mainImage); } catch (_) { /* Preview is already loaded. */ }
        if (id !== motionId || selection !== selectionId) return;
        updateThumbnailState(thumbnail, true);
        motionFrame = requestAnimationFrame(() => { if (id === motionId) clearInlineMotion(); });
      }, 300);
    };
    mainMedia.addEventListener('touchstart', event => {
      if (!isMobileGallery() || event.touches.length !== 1 || settling) return;
      ++selectionId;
      mainMedia.removeAttribute('aria-busy');
      clearInlineMotion();
      touchStartX = lastTouchX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      lastTouchTime = performance.now();
      touchActive = true;
      horizontalDrag = false;
    }, { passive: true });
    mainMedia.addEventListener('touchmove', event => {
      if (!touchActive || !isMobileGallery() || event.touches.length !== 1) return;
      const touch = event.touches[0];
      let deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (!horizontalDrag) {
        if (Math.abs(deltaX) < 7 && Math.abs(deltaY) < 7) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) { touchActive = false; return; }
        horizontalDrag = true;
        mainMedia.dataset.bbZoomSuppressedUntil = String(performance.now() + 650);
      }
      event.preventDefault();
      if (!prepareSwipeTarget(deltaX)) deltaX *= 0.28;
      currentDeltaX = deltaX;
      setDragPosition(deltaX);
      lastTouchX = touch.clientX;
      lastTouchTime = performance.now();
    }, { passive: false });
    mainMedia.addEventListener('touchend', event => {
      if (!touchActive) return;
      touchActive = false;
      const touch = event.changedTouches[0];
      if (!touch || !horizontalDrag) { horizontalDrag = false; clearInlineMotion(); return; }
      const deltaX = touch.clientX - touchStartX, deltaY = touch.clientY - touchStartY;
      const velocity = (touch.clientX - lastTouchX) / Math.max(performance.now() - lastTouchTime, 1);
      horizontalDrag = false;
      mainMedia.dataset.bbZoomSuppressedUntil = String(performance.now() + 650);
      if (Math.abs(deltaX) > Math.abs(deltaY) && targetThumbnail &&
          (Math.abs(currentDeltaX) >= mainMedia.clientWidth * 0.18 || Math.abs(velocity) >= 0.45)) animateToTarget();
      else animateBack();
    }, { passive: true });
    mainMedia.addEventListener('touchcancel', () => {
      touchActive = false;
      horizontalDrag = false;
      animateBack();
    }, { passive: true });
  });
};

initializeProductGalleries();

document.addEventListener('shopify:section:load', (event) => {
  initializeProductGalleries(event.target);
});

const initializeProductLightboxes = (root = document) => {
  root.querySelectorAll('.bb-product-gallery').forEach((wrapper) => {
    if (wrapper.dataset.productLightboxReady === 'true') return;

    const lightbox = wrapper.querySelector('[data-bb-product-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-bb-product-lightbox-image]');
    const lightboxContent = lightbox?.querySelector('.bb-product-lightbox__content');
    const closeButton = lightbox?.querySelector('[data-bb-product-lightbox-close]');
    const desktopTriggers = Array.from(wrapper.querySelectorAll('[data-bb-product-zoom-trigger]'));
    const mainMedia = wrapper.querySelector('[data-bb-product-main-media]');
    const mainImage = wrapper.querySelector('[data-bb-product-main-image]');
    if (!lightbox || !lightboxImage || !closeButton) return;

    wrapper.dataset.productLightboxReady = 'true';
    let previousBodyOverflow = '';
    let lastTrigger = null;
    let closeTimer = null;

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    const sourceForImage = (image) => {
      if (!image) return '';
      return image.dataset.fullSrc || image.getAttribute('src') || image.currentSrc || '';
    };

    const fitLightboxToViewport = () => {
      // v1107: sizing is enforced by a fixed inset box in CSS.
      // Clear older inline constraints so the image can only fill that box with object-fit: contain.
      lightbox.style.removeProperty('--bb-lightbox-max-width');
      lightbox.style.removeProperty('--bb-lightbox-max-height');
      lightboxImage.style.removeProperty('max-width');
      lightboxImage.style.removeProperty('max-height');
      lightboxImage.style.removeProperty('width');
      lightboxImage.style.removeProperty('height');
    };

    const openLightbox = (image, trigger = null) => {
      const src = sourceForImage(image);
      if (!src) return;

      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      lastTrigger = trigger;
      fitLightboxToViewport();
      lightboxImage.src = src;
      lightboxImage.alt = image.alt || '';
      lightboxImage.width = image.naturalWidth || Number(image.getAttribute('width')) || 1920;
      lightboxImage.height = image.naturalHeight || Number(image.getAttribute('height')) || 1080;
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      window.requestAnimationFrame(() => {
        lightbox.classList.add('is-open');
        closeButton.focus({ preventScroll: true });
      });
    };

    const closeLightbox = () => {
      if (lightbox.hidden) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousBodyOverflow;

      const finish = () => {
        lightbox.hidden = true;
        lightboxImage.removeAttribute('src');
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus({ preventScroll: true });
        }
        lastTrigger = null;
      };

      if (reduceMotion()) finish();
      else closeTimer = window.setTimeout(finish, 180);
    };

    desktopTriggers.forEach((trigger) => {
      const openFromTrigger = () => {
        const image = trigger.querySelector('img');
        openLightbox(image, trigger);
      };

      trigger.addEventListener('click', (event) => {
        if (event.target.closest('a, button')) return;
        event.preventDefault();
        openFromTrigger();
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openFromTrigger();
      });
    });

    if (mainMedia && mainImage) {
      mainMedia.addEventListener('click', (event) => {
        if (!isMobile()) return;
        const suppressedUntil = Number(mainMedia.dataset.bbZoomSuppressedUntil || 0);
        if (performance.now() < suppressedUntil) return;
        if (event.target.closest('button, a')) return;
        openLightbox(mainImage);
      });
    }

    const handleLightboxViewportChange = () => {
      if (!lightbox.hidden) fitLightboxToViewport();
    };

    window.addEventListener('resize', handleLightboxViewportChange, { passive: true });
    window.visualViewport?.addEventListener('resize', handleLightboxViewportChange, { passive: true });

    closeButton.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target === lightboxContent) closeLightbox();
    });
    lightboxImage.addEventListener('click', (event) => event.stopPropagation());

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  });
};

initializeProductLightboxes();

document.addEventListener('shopify:section:load', (event) => {
  initializeProductLightboxes(event.target);
});

const updateBrandCarousel = (carousel) => {
  const track = carousel.querySelector('[data-bb-brand-track]');
  const previous = carousel.querySelector('[data-bb-brand-previous]');
  const next = carousel.querySelector('[data-bb-brand-next]');
  if (!track || !previous || !next) return;

  const desktop = window.matchMedia('(min-width: 990px)').matches;
  const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
  const hasOverflow = desktop && maxScroll > 2;
  carousel.classList.toggle('has-overflow', hasOverflow);
  previous.disabled = !hasOverflow || track.scrollLeft <= 2;
  next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
};

const moveBrandCarousel = (carousel, direction) => {
  const track = carousel.querySelector('[data-bb-brand-track]');
  const card = track?.querySelector('.bb-brand-card');
  if (!track || !card) return;

  const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  track.scrollBy({
    left: direction * (card.getBoundingClientRect().width + gap),
    behavior: reduceMotion ? 'auto' : 'smooth'
  });
};

const initializeBrandCarousels = (root = document) => {
  root.querySelectorAll('[data-bb-brand-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-bb-brand-track]');
    const previous = carousel.querySelector('[data-bb-brand-previous]');
    const next = carousel.querySelector('[data-bb-brand-next]');
    if (!track || !previous || !next) return;

    if (carousel.dataset.carouselReady !== 'true') {
      carousel.dataset.carouselReady = 'true';
      previous.addEventListener('click', () => moveBrandCarousel(carousel, -1));
      next.addEventListener('click', () => moveBrandCarousel(carousel, 1));
      track.addEventListener('scroll', () => updateBrandCarousel(carousel), { passive: true });

      let pointerId;
      let pointerStartX = 0;
      let scrollStart = 0;
      let dragged = false;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        scrollStart = track.scrollLeft;
        dragged = false;
      });

      track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - pointerStartX;
        if (!dragged && Math.abs(distance) > 10) {
          dragged = true;
          track.setPointerCapture(pointerId);
          track.classList.add('is-dragging');
        }
        if (!dragged) return;
        event.preventDefault();
        track.scrollLeft = scrollStart - distance;
      });

      const endDrag = (event) => {
        if (event.pointerId !== pointerId) return;
        if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
        track.classList.remove('is-dragging');
        if (dragged) {
          carousel.dataset.suppressCardClick = 'true';
          window.setTimeout(() => delete carousel.dataset.suppressCardClick, 0);
        }
        pointerId = undefined;
        updateBrandCarousel(carousel);
      };

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', (event) => {
        if (carousel.dataset.suppressCardClick !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    updateBrandCarousel(carousel);
  });
};

initializeBrandCarousels();

document.addEventListener('shopify:section:load', (event) => {
  initializeBrandCarousels(event.target);
});

let brandCarouselResizeFrame;
window.addEventListener('resize', () => {
  window.cancelAnimationFrame(brandCarouselResizeFrame);
  brandCarouselResizeFrame = window.requestAnimationFrame(() => {
    document.querySelectorAll('[data-bb-brand-carousel]').forEach(updateBrandCarousel);
  });
});

/*
 * Keep the brand shortcuts on Todos los productos synchronized with the
 * brands configured in the homepage "Blueboat | Marcas" section.
 *
 * Shopify does not expose another JSON template section's block settings to
 * Liquid on the collection template, so the collection page reads the
 * rendered homepage and mirrors its current brand blocks. This preserves the
 * exact homepage order, image, title and collection link without maintaining
 * a second manual list.
 */
/*
 * Homepage featured products:
 * - Nuevo: randomize the complete rendered catalog pool.
 * - Top Sellers: Producto TOP + Min. 10 u. first (random), then remaining Producto TOP (random).
 */
const initializeHomeFeaturedProductRandomization = (root = document) => {
  root.querySelectorAll('[data-bb-home-random-mode]').forEach((track) => {
    if (track.dataset.bbHomeRandomized === 'true') return;
    track.dataset.bbHomeRandomized = 'true';

    const items = Array.from(track.children).filter((item) => item.matches('.bb-home-product-card'));
    const shuffle = (group) => {
      const copy = [...group];
      for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    };

    let orderedItems = [];
    if (track.dataset.bbHomeRandomMode === 'top-priority') {
      const topMin10 = items.filter(
        (item) => item.dataset.bbProductTop === 'true' && item.getAttribute('data-bb-min-10') === 'true'
      );
      const topOther = items.filter(
        (item) => item.dataset.bbProductTop === 'true' && item.getAttribute('data-bb-min-10') !== 'true'
      );
      orderedItems = [...shuffle(topMin10), ...shuffle(topOther)];
    } else {
      orderedItems = shuffle(items);
    }

    orderedItems.forEach((item) => track.appendChild(item));
    track.scrollLeft = 0;
    const carousel = track.closest('[data-bb-product-carousel]');
    if (carousel) updateProductCarousel(carousel);
  });
};

initializeHomeFeaturedProductRandomization();
document.addEventListener('shopify:section:load', (event) => initializeHomeFeaturedProductRandomization(event.target));

const initializeRandomProductTracks = (root = document) => {
  root.querySelectorAll('[data-bb-randomize-limit]').forEach((track) => {
    if (track.dataset.bbRandomized === 'true') return;
    track.dataset.bbRandomized = 'true';

    const limit = Math.max(1, Number.parseInt(track.dataset.bbRandomizeLimit || '10', 10) || 10);
    const items = Array.from(track.children);
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    items.forEach((item, index) => {
      if (index < limit) track.appendChild(item);
      else item.remove();
    });

    const carousel = track.closest('[data-bb-product-carousel]');
    if (carousel) updateProductCarousel(carousel);
  });
};

initializeRandomProductTracks();
document.addEventListener('shopify:section:load', (event) => initializeRandomProductTracks(event.target));

/*
 * Todos los productos ordering:
 * 1) Producto TOP + Min. 10 u. (randomized)
 * 2) remaining Producto TOP (randomized)
 * 3) regular products in their rendered order
 * Rendering up to 250 products in Liquid keeps the final grid fully populated.
 */
const initializeTopFirstCollectionGrids = (root = document) => {
  root.querySelectorAll('[data-bb-randomize-top-first]').forEach((grid) => {
    if (grid.dataset.bbTopFirstRandomized === 'true') return;
    grid.dataset.bbTopFirstRandomized = 'true';

    const items = Array.from(grid.children).filter((item) => item.matches('.bb-product-card'));
    const topMin10Items = items.filter(
      (item) => item.dataset.bbProductTop === 'true' && item.getAttribute('data-bb-min-10') === 'true'
    );
    const topOtherItems = items.filter(
      (item) => item.dataset.bbProductTop === 'true' && item.getAttribute('data-bb-min-10') !== 'true'
    );
    const regularItems = items.filter((item) => item.dataset.bbProductTop !== 'true');

    const shuffle = (group) => {
      for (let i = group.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [group[i], group[j]] = [group[j], group[i]];
      }
      return group;
    };

    [
      ...shuffle(topMin10Items),
      ...shuffle(topOtherItems),
      ...regularItems
    ].forEach((item) => grid.appendChild(item));
  });
};

initializeTopFirstCollectionGrids();
document.addEventListener('shopify:section:load', (event) => initializeTopFirstCollectionGrids(event.target));

// Keep brand requests in the same theme as the page being previewed.
// Without an explicit preview ID, a homepage request can load the published
// theme and replace a new theme's logos with an older version.
const getBrandSyncHomeUrl = (homeUrl) => {
  const url = new URL(homeUrl || '/', window.location.origin);
  const pageParams = new URLSearchParams(window.location.search);
  const currentTheme = window.Shopify?.theme;
  const previewThemeId = pageParams.get('preview_theme_id') ||
    (currentTheme?.role !== 'main' ? currentTheme?.id : '');
  if (previewThemeId) url.searchParams.set('preview_theme_id', String(previewThemeId));
  if (pageParams.has('preview_key')) url.searchParams.set('preview_key', pageParams.get('preview_key') || '');
  return url.href;
};

const initializeHomeBrandSync = (root = document) => {
  root.querySelectorAll('[data-bb-home-brands-sync]').forEach((nav) => {
    if (nav.dataset.homeBrandsSyncReady === 'true') return;
    nav.dataset.homeBrandsSyncReady = 'true';

    const track = nav.querySelector('[data-bb-brand-list]');
    if (!track) return;

    const homeUrl = nav.dataset.bbHomeUrl || nav.dataset.homeUrl || '/';
    const absoluteHomeUrl = getBrandSyncHomeUrl(homeUrl);
    const brandFilterTag = (nav.dataset.bbBrandFilterTag || '').trim().replace(/^\/+|\/+$/g, '');
    const nativeBrandItems = new Map([
      ['demaf', track.querySelector('[data-bb-demaf-brand-logo]')?.closest('a.bb-all-products-brands__item')],
      ['madeca21', track.querySelector('[data-bb-madeca21-brand-logo]')?.closest('a.bb-all-products-brands__item')]
    ].filter(([, item]) => item));

    fetch(absoluteHomeUrl, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Homepage request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const homepage = parser.parseFromString(html, 'text/html');
        const sourceList = homepage.querySelector('#productos [data-bb-brand-list], .bb-products [data-bb-brand-list]');
        if (!sourceList) return;

        const sourceItems = Array.from(sourceList.querySelectorAll('[data-bb-home-brand-item], .bb-brand-logo-item'));
        if (!sourceItems.length) return;

        const fragment = document.createDocumentFragment();
        const renderedBrands = new Set();

        sourceItems.forEach((sourceItem) => {
          const sourceLink = sourceItem.querySelector('a.bb-brand-logo-link');
          const sourceContainer = sourceLink || sourceItem.querySelector('.bb-brand-logo-link');
          const sourceImage = sourceItem.querySelector('img');
          const sourcePlaceholder = sourceItem.querySelector('svg');
          const title = (
            sourceItem.dataset.bbBrandTitle ||
            sourceItem.dataset.brandTitle ||
            sourceImage?.getAttribute('alt') ||
            sourceContainer?.getAttribute('aria-label') ||
            ''
          ).replace(/^Ver productos de\s+/i, '').trim();
          const brandKey = title.toLowerCase();
          if (renderedBrands.has(brandKey)) return;
          renderedBrands.add(brandKey);
          const nativeBrandItem = nativeBrandItems.get(brandKey);
          if (nativeBrandItem) {
            fragment.appendChild(nativeBrandItem.cloneNode(true));
            return;
          }

          let href = sourceItem.dataset.bbBrandUrl || sourceItem.dataset.brandUrl || sourceLink?.getAttribute('href') || '';
          if (!href && title) {
            const slug = title
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
              .trim()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
            if (slug) {
              const base = new URL(absoluteHomeUrl);
              const basePath = base.pathname.endsWith('/') ? base.pathname : `${base.pathname}/`;
              href = `${basePath}collections/${slug}`.replace(/\/+/g, '/');
            }
          }

          // Native vendor collection URLs use a query string and cannot
          // inherit a collection tag path. Keep this resilient brand fallback
          // link functional until the named collection exists.
          const isVendorFallback = href && /\/collections\/vendors\/?$/.test(new URL(href, window.location.origin).pathname);
          if (href && brandFilterTag && !isVendorFallback) {
            const resolved = new URL(href, window.location.origin);
            resolved.pathname = `${resolved.pathname.replace(/\/+$/g, '')}/${brandFilterTag}`;
            href = `${resolved.pathname}${resolved.search}${resolved.hash}`;
          }

          const item = document.createElement('a');
          item.className = 'bb-all-products-brands__item';
          item.href = href || '#';
          item.setAttribute(
            'aria-label',
            title
              ? brandFilterTag && !isVendorFallback
                ? `Ver Top Sellers de ${title}`
                : `Ver productos de ${title}`
              : 'Ver productos de la marca'
          );
          if (!href) item.setAttribute('aria-disabled', 'true');

          const media = document.createElement('span');
          media.className = 'bb-all-products-brands__media';

          if (sourceImage) {
            const image = document.createElement('img');
            ['src', 'srcset', 'width', 'height'].forEach((attribute) => {
              const value = sourceImage.getAttribute(attribute);
              if (value) image.setAttribute(attribute, value);
            });
            image.alt = sourceImage.getAttribute('alt') || title;
            image.loading = 'lazy';
            image.decoding = 'async';
            media.appendChild(image);
          } else if (sourcePlaceholder) {
            media.innerHTML = sourcePlaceholder.outerHTML;
            media.firstElementChild?.classList.add('bb-all-products-brands__placeholder');
          }

          const name = document.createElement('span');
          name.className = 'bb-all-products-brands__name';
          name.textContent = title;

          item.append(media, name);
          fragment.appendChild(item);
        });

        nativeBrandItems.forEach((item, brandKey) => {
          if (!renderedBrands.has(brandKey)) fragment.appendChild(item.cloneNode(true));
        });

        track.replaceChildren(fragment);
        track.classList.remove('is-expanded');

        const toggle = nav.querySelector('[data-bb-brand-toggle]');
        const toggleWrap = nav.querySelector('.bb-all-products-brands__toggle-wrap');
        const brandCount = track.querySelectorAll('.bb-all-products-brands__item').length;
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = toggle.dataset.showLabel || 'Ver todo';
        }
        if (toggleWrap) {
          toggleWrap.hidden = brandCount <= 4;
        }
      })
      .catch(() => {
        // Keep the server-rendered fallback list if the homepage cannot be read.
      });
  });
};

initializeHomeBrandSync();

document.addEventListener('shopify:section:load', (event) => {
  initializeHomeBrandSync(event.target);
});


/*
 * Keep each brand collection header logo synchronized with the matching brand
 * configured in the homepage "Blueboat | Marcas" section. Descriptive copy is
 * intentionally kept in Liquid so it is available without JavaScript.
 */
const initializeBrandDetailSync = (root = document) => {
  root.querySelectorAll('[data-bb-brand-detail-sync]').forEach((profile) => {
    if (profile.dataset.bbBrandDetailSyncReady === 'true') return;
    profile.dataset.bbBrandDetailSyncReady = 'true';

    const targetHandle = (profile.dataset.bbBrandHandle || '').trim().toLowerCase();
    const media = profile.querySelector('[data-bb-brand-detail-media]');
    if (!targetHandle || !media) return;
    // The official Demaf asset is already server-rendered from this theme.
    if (targetHandle === 'demaf' && media.querySelector('[data-bb-demaf-brand-logo]')) return;
    if (targetHandle === 'madeca21' && media.querySelector('[data-bb-madeca21-brand-logo]')) return;

    const homeUrl = profile.dataset.bbHomeUrl || '/';
    const absoluteHomeUrl = getBrandSyncHomeUrl(homeUrl);

    fetch(absoluteHomeUrl, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Homepage request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const homepage = parser.parseFromString(html, 'text/html');
        const sourceList = homepage.querySelector('#productos [data-bb-brand-list], .bb-products [data-bb-brand-list]');
        if (!sourceList) return;

        const sourceItems = Array.from(sourceList.querySelectorAll('[data-bb-home-brand-item], .bb-brand-logo-item'));
        const sourceItem = sourceItems.find((item) => {
          const sourceLink = item.querySelector('a.bb-brand-logo-link');
          const href = item.dataset.bbBrandUrl || item.dataset.brandUrl || sourceLink?.getAttribute('href') || '';
          if (href) {
            try {
              const path = new URL(href, window.location.origin).pathname.replace(/\/$/, '');
              if (path.endsWith(`/collections/${targetHandle}`)) return true;
            } catch (error) {}
          }

          const title = (
            item.dataset.bbBrandTitle ||
            item.dataset.brandTitle ||
            item.querySelector('img')?.getAttribute('alt') ||
            ''
          ).trim();
          const slug = title
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          return slug === targetHandle;
        });

        if (!sourceItem) return;
        const sourceImage = sourceItem.querySelector('img');
        if (!sourceImage) return;

        const image = document.createElement('img');
        ['src', 'srcset', 'width', 'height'].forEach((attribute) => {
          const value = sourceImage.getAttribute(attribute);
          if (value) image.setAttribute(attribute, value);
        });
        image.alt = sourceImage.getAttribute('alt') || profile.closest('.bb-section__head')?.querySelector('.bb-section__title')?.textContent?.trim() || '';
        image.loading = 'eager';
        image.decoding = 'async';
        media.replaceChildren(image);
      })
      .catch(() => {
        // Keep the server-rendered fallback logo if homepage sync is unavailable.
      });
  });
};

initializeBrandDetailSync();

document.addEventListener('shopify:section:load', (event) => {
  initializeBrandDetailSync(event.target);
});

const initializePurchaseQuantityControls = (root = document) => {
  root.querySelectorAll('[data-bb-purchase-quantity]').forEach((input) => {
    if (input.dataset.bbPurchaseQuantityReady === 'true') return;
    input.dataset.bbPurchaseQuantityReady = 'true';

    const form = input.closest('form');
    const control = input.closest('.bb-quantity-control');
    const hidden = control?.querySelector('[data-bb-shopify-quantity]');
    const unit = control?.querySelector('[data-bb-quantity-unit]');
    const caseCountProperty = control?.querySelector('[data-bb-case-count-property]');
    const caseUnitsProperty = control?.querySelector('[data-bb-case-units-property]');
    const caseTotalProperty = control?.querySelector('[data-bb-case-total-property]');
    const select = form?.querySelector('[data-product-variant-select]');
    const button = form?.querySelector('[data-add-to-cart]');
    const status = form?.querySelector('[data-bb-product-form-status]');
    const isCase = input.dataset.bbIsCase === 'true';
    const unitsPerCase = Math.max(1, Number.parseInt(input.dataset.bbUnitsPerCase || '1', 10) || 1);
    const maxUnits = Math.max(10, Number.parseInt(input.dataset.bbMaxUnits || '299', 10) || 299);
    const maxCases = Math.max(1, Number.parseInt(input.dataset.bbMaxCases || '9', 10) || 9);
    const sampleLimitOne = input.dataset.bbSampleLimitOne === 'true';
    let lastMode = '';

    const getMode = () => {
      const option = select?.options?.[select.selectedIndex];
      if (option?.dataset.bbSampleVariant === 'true') return 'sample';
      return isCase ? 'case' : 'unit';
    };

    const setStockError = (message = '') => {
      if (!status) return;
      if (message) {
        status.textContent = message;
        status.className = 'bb-product-form__status is-error is-stock-error';
      } else if (status.classList.contains('is-stock-error')) {
        status.textContent = '';
        status.className = 'bb-product-form__status';
      }
    };

    const sync = (resetWhenModeChanges = false, commit = false) => {
      const mode = getMode();
      const minimum = mode === 'unit' ? 10 : 1;
      const inventoryMeta = getVariantInventoryMeta(form);
      const shouldRespectInventory = !isCase;
      const inventoryDisplay = shouldRespectInventory && inventoryMeta.managed
        ? (mode === 'case' ? Math.floor(inventoryMeta.quantity / unitsPerCase) : inventoryMeta.quantity)
        : null;

      let maximum = mode === 'unit'
        ? maxUnits
        : mode === 'case'
          ? maxCases
          : mode === 'sample' && sampleLimitOne
            ? 1
            : null;

      if (shouldRespectInventory && inventoryMeta.managed) {
        maximum = maximum === null ? inventoryDisplay : Math.min(maximum, inventoryDisplay);
      }

      if (resetWhenModeChanges && lastMode && lastMode !== mode) {
        input.value = String(minimum);
      }

      input.min = String(minimum);
      if (maximum === null) input.removeAttribute('max');
      else input.max = String(Math.max(0, maximum));

      const isCaseMode = mode === 'case';
      [caseCountProperty, caseUnitsProperty, caseTotalProperty].forEach((propertyInput) => {
        if (propertyInput) propertyInput.disabled = !isCaseMode;
      });

      if (unit) {
        unit.textContent = mode === 'sample' ? 'muestra(s)' : mode === 'case' ? 'caja(s)' : 'unidad(es)';
      }

      const rawInput = String(input.value ?? '').trim();
      let parsedAmount = Number.parseInt(rawInput, 10);
      const hasNumber = rawInput !== '' && Number.isFinite(parsedAmount);

      // While the customer is typing, allow an empty field or an intermediate value
      // below the MOQ so "10" can be erased and replaced naturally (e.g. 10 → 15).
      if (!hasNumber && !commit) {
        if (hidden) hidden.value = '';
        if (isCaseMode) {
          if (caseCountProperty) caseCountProperty.value = '';
          if (caseUnitsProperty) caseUnitsProperty.value = String(unitsPerCase);
          if (caseTotalProperty) caseTotalProperty.value = '';
        }
        if (button) {
          button.disabled = true;
          button.textContent = 'Agregar al carrito';
        }
        setStockError('');
        lastMode = mode;
        return;
      }

      if (!hasNumber) parsedAmount = minimum;
      if (commit && parsedAmount < minimum) parsedAmount = minimum;

      const canMeetMinimum = !shouldRespectInventory || (inventoryMeta.available && (maximum === null || maximum >= minimum));
      const belowMinimum = parsedAmount < minimum;
      const exceedsInventory = shouldRespectInventory && inventoryMeta.managed && parsedAmount > inventoryMeta.quantity;
      const amount = exceedsInventory || belowMinimum
        ? parsedAmount
        : (canMeetMinimum && maximum !== null ? Math.min(parsedAmount, maximum) : parsedAmount);

      // Never overwrite an intermediate value below MOQ while typing.
      // On blur/change, normalize it back to the minimum.
      if (commit || !belowMinimum) input.value = String(amount);

      const shopifyQuantity = mode === 'case' ? amount * unitsPerCase : amount;
      if (hidden) hidden.value = belowMinimum && !commit ? '' : String(shopifyQuantity);

      if (isCaseMode) {
        if (caseCountProperty) caseCountProperty.value = belowMinimum && !commit ? '' : String(amount);
        if (caseUnitsProperty) caseUnitsProperty.value = String(unitsPerCase);
        if (caseTotalProperty) caseTotalProperty.value = belowMinimum && !commit ? '' : String(shopifyQuantity);
      }

      if (belowMinimum && !commit) {
        if (button) {
          button.disabled = true;
          button.textContent = 'Agregar al carrito';
        }
        setStockError('');
      } else if (!canMeetMinimum) {
        if (button) {
          button.disabled = true;
          button.textContent = inventoryMeta.managed && inventoryMeta.quantity <= 0 ? 'Agotado' : 'Stock insuficiente';
        }

        if (!inventoryMeta.available && !inventoryMeta.managed) {
          setStockError('Este producto no está disponible para pedidos online.');
        } else if (mode === 'unit') {
          setStockError(`Inventario disponible: ${inventoryMeta.quantity} unidades. El pedido mínimo es de 10 unidades.`);
        } else {
          setStockError('Esta muestra está agotada.');
        }
      } else if (exceedsInventory) {
        if (button) {
          button.disabled = true;
          button.textContent = 'Agregar al carrito';
        }
        setStockError(`Puedes comprar hasta ${inventoryMeta.quantity} unidades de este producto.`);
      } else {
        if (button) {
          button.disabled = false;
          button.textContent = 'Agregar al carrito';
        }
        setStockError('');
      }

      lastMode = mode;
    };

    input.addEventListener('input', () => sync(false, false));
    input.addEventListener('change', () => sync(false, true));
    input.addEventListener('blur', () => sync(false, true));
    select?.addEventListener('change', () => sync(true, true));
    sync(false, true);
  });
  root.querySelectorAll('[data-bb-cart-case-count]').forEach((input) => {
    if (input.dataset.bbCartCaseQuantityReady === 'true') return;
    input.dataset.bbCartCaseQuantityReady = 'true';
    const wrapper = input.closest('.bb-cart-item__quantity');
    const hidden = wrapper?.querySelector('[data-bb-cart-shopify-quantity]');
    const unitsPerCase = Math.max(1, Number.parseInt(input.dataset.bbUnitsPerCase || '1', 10) || 1);
    const sync = () => {
      const cases = Math.min(9, Math.max(0, Number.parseInt(input.value || '0', 10) || 0));
      input.max = '9';
      input.value = String(cases);
      if (hidden) hidden.value = String(cases * unitsPerCase);
    };
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  });
};

initializePurchaseQuantityControls();
document.addEventListener('shopify:section:load', (event) => initializePurchaseQuantityControls(event.target));

/* v1075 — cart page uses the same quantity controls as the cart drawer */
const showCartPageStatus = (message = '') => {
  const status = document.querySelector('[data-bb-cart-page-status]');
  if (!status) return;
  status.textContent = message;
  status.hidden = !message;
};

const changeCartPageLine = async (lineKey, quantity, caseUnits = 0) => {
  const page = document.querySelector('[data-bb-cart-page]');
  page?.classList.add('is-updating');
  showCartPageStatus('');

  try {
    let properties = null;
    const normalizedCaseUnits = Math.max(0, Number.parseInt(String(caseUnits || '0'), 10) || 0);

    if (quantity > 0 && normalizedCaseUnits > 0) {
      const currentCart = await fetchCartState();
      const currentItem = (currentCart.items || []).find((item) => item.key === lineKey);
      properties = buildCaseLineProperties(currentItem?.properties || {}, quantity, normalizedCaseUnits);
    }

    const payload = await postCartLineChange({ id: lineKey, quantity, properties });
    updateHeaderCartCount(payload.item_count, true);
    window.location.reload();
  } catch (error) {
    console.error(error);
    page?.classList.remove('is-updating');
    showCartPageStatus(error?.message || 'No se pudo actualizar el carrito.');
  }
};

document.addEventListener('click', (event) => {
  const removeButton = event.target.closest('[data-bb-cart-page-remove]');
  if (removeButton) {
    event.preventDefault();
    const lineKey = removeButton.dataset.bbCartLineKey;
    if (lineKey) changeCartPageLine(lineKey, 0);
    return;
  }

  const quantityButton = event.target.closest('[data-bb-cart-page-qty-action]');
  if (!quantityButton) return;

  event.preventDefault();
  if (quantityButton.disabled) return;

  const lineKey = quantityButton.dataset.bbCartLineKey;
  const current = Math.max(0, Number.parseInt(quantityButton.dataset.bbCartRawQuantity || '0', 10) || 0);
  const step = Math.max(1, Number.parseInt(quantityButton.dataset.bbCartStep || '1', 10) || 1);
  const minimum = Math.max(0, Number.parseInt(quantityButton.dataset.bbCartMin || '0', 10) || 0);
  const parsedMaximum = Number.parseInt(quantityButton.dataset.bbCartMax || '999999', 10);
  const maximum = Number.isFinite(parsedMaximum) ? Math.max(0, parsedMaximum) : 999999;
  const direction = quantityButton.dataset.bbCartPageQtyAction === 'decrease' ? -1 : 1;
  const attemptedQuantity = direction < 0 ? current - step : current + step;
  const nextQuantity = direction < 0
    ? Math.max(minimum, attemptedQuantity)
    : Math.min(maximum, attemptedQuantity);
  const caseUnits = Math.max(0, Number.parseInt(quantityButton.dataset.bbCartCaseUnits || '0', 10) || 0);
  const parsedStockMaximum = Number.parseInt(quantityButton.dataset.bbCartStockMax || '', 10);
  const stockMaximum = Number.isFinite(parsedStockMaximum) ? Math.max(0, parsedStockMaximum) : null;

  if (direction > 0 && attemptedQuantity > maximum) {
    if (stockMaximum !== null && maximum === stockMaximum) {
      showCartPageStatus(`Puedes comprar hasta ${stockMaximum} unidades de este producto.`);
    } else if (caseUnits > 0) {
      showCartPageStatus('Para 10 cajas o más, solicita una cotización.');
    }
    return;
  }

  showCartPageStatus('');
  if (lineKey && nextQuantity !== current) changeCartPageLine(lineKey, nextQuantity, caseUnits);
});

/* v1071 — submit contact forms in place and always expose Shopify's success state */
const initializeContactForms = (root = document) => {
  root.querySelectorAll('[data-bb-contact-form], #BlueboatContactForm').forEach((form) => {
    if (form.dataset.bbContactReady === 'true') return;
    form.dataset.bbContactReady = 'true';

    const successStatus = form.querySelector('[data-bb-contact-success]');
    const errorStatus = form.querySelector('[data-bb-contact-error]');
    const fields = form.querySelector('[data-bb-contact-fields]');
    const submitButton = form.querySelector('[data-bb-contact-submit]');

    const hideStatus = (status) => {
      if (!status) return;
      status.hidden = true;
    };

    const showError = (message) => {
      hideStatus(successStatus);
      if (fields) fields.hidden = false;
      form.classList.remove('is-success');
      if (!errorStatus) return;
      errorStatus.innerHTML = message;
      errorStatus.hidden = false;
    };

    const showSuccess = ({ reset = true, updateUrl = true } = {}) => {
      if (reset) form.reset();
      hideStatus(errorStatus);
      if (fields) fields.hidden = true;
      form.classList.add('is-success');

      if (successStatus) {
        successStatus.hidden = false;
        window.requestAnimationFrame(() => successStatus.focus({ preventScroll: true }));
      }

      if (updateUrl) {
        const successUrl = new URL(window.location.href);
        successUrl.searchParams.set('contact_posted', 'true');
        successUrl.hash = form.id || 'BlueboatContactForm';
        window.history.replaceState(window.history.state, '', `${successUrl.pathname}${successUrl.search}${successUrl.hash}`);
        document.documentElement.classList.add('bb-contact-posted');
        window.dispatchEvent(new CustomEvent('bb:contact:success', {
          detail: { formId: form.id || 'BlueboatContactForm' }
        }));
      }
    };

    const pageWasSubmitted = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    if (pageWasSubmitted || (successStatus && !successStatus.hidden)) {
      showSuccess({ reset: false, updateUrl: false });
    }

    form.addEventListener('submit', async (event) => {
      if (!form.checkValidity()) return;

      event.preventDefault();
      if (form.dataset.bbContactSubmitting === 'true') return;

      form.dataset.bbContactSubmitting = 'true';
      hideStatus(successStatus);
      hideStatus(errorStatus);

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      try {
        const actionUrl = new URL(form.action, window.location.href);
        actionUrl.hash = '';
        const encodedForm = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (typeof value === 'string') encodedForm.append(key, value);
        });

        const response = await fetch(actionUrl.toString(), {
          method: 'POST',
          body: encodedForm,
          credentials: 'same-origin',
          redirect: 'follow',
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        const responseHtml = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
        const returnedForm = responseDocument.querySelector('#BlueboatContactForm');
        const returnedSuccess = returnedForm?.querySelector('[data-bb-contact-success]:not([hidden])');
        const returnedError = returnedForm?.querySelector('[data-bb-contact-error]:not([hidden])');
        const responseUrl = new URL(response.url || form.action, window.location.href);
        const challenge = responseDocument.querySelector('.shopify-challenge__container, form[action*="/challenge"], [data-shopify-captcha]');
        const wasSubmitted = responseUrl.searchParams.get('contact_posted') === 'true'
          || Boolean(returnedSuccess)
          || responseHtml.includes('contact_posted=true');

        if (challenge && response.url) {
          window.location.assign(response.url);
          return;
        }

        if (response.ok && (wasSubmitted || (returnedForm && !returnedError))) {
          showSuccess();
        } else if (returnedError?.innerHTML.trim()) {
          showError(returnedError.innerHTML);
        } else {
          showError('No pudimos enviar el formulario. Inténtalo de nuevo.');
        }
      } catch (error) {
        console.error(error);
        showError('No pudimos enviar el formulario. Inténtalo de nuevo.');
      } finally {
        delete form.dataset.bbContactSubmitting;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      }
    });
  });
};

initializeContactForms();
document.addEventListener('shopify:section:load', (event) => initializeContactForms(event.target));
